import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { CardVisibilityTabs } from '../card-visibility-tabs';
import { config } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { SavedCardTableProps as Props } from './types';

const renderPrepend = () => <CardVisibilityTabs />;
const finalConfig = { ...config, renderTablePrependStable: renderPrepend };

export const SavedCardTable = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('SavedCardTable', className)}
      sx={SX.root}
      config={finalConfig}
    />
  );
});

SavedCardTable.displayName = 'SavedCardTable';
